<template>
    <div :class="customClass">
        <div v-if="cleanConditions && cleanConditions.length > 0">
            <div v-html="getValueFromCondition"></div>
        </div>
        <div v-if="!cleanConditions || cleanConditions.length == 0 ">
            <span> {{ formatValue }}</span>
        </div>
    </div>
</template>
<script>
    import _ from "lodash";
    import GenericTableService from '@/shared/services/genericConfig/GenericTableService.js';

    /**
     * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LOS NUMEROS
     * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
     * */
    export default {
        name: "cell-dt-number-type-component",
        data() {
            return {
            }
        },
        props: ['value', 'format', 'outcomes', 'currency', 'area', 'frequency', 'precedent', 'readTransform', 'conditionsDict', 'index'],
        computed: {
            formatValue() {
                if (this.value == null || this.value === 'undefined')
                    return null;

                let transformedValue;

                transformedValue = GenericTableService.getReadTransform(this.value, this.readTransform);

                let replacedValue = GenericTableService.getFormatAndSuffix(this.currency, this.area, this.frequency, this.precedent, transformedValue != undefined ? transformedValue : this.value, this.format, this.$t("defaultlocale"));

                return replacedValue;
            },
            cleanConditions(){
                return  this.conditionsDict.filter(x => x.Value != '')
            },
            getValueFromCondition() {
                var found = false;
                var index = 0;
                // Eval expression
                while (!found && index < this.cleanConditions.length) {
                    found = this.$parent.fnEvalCondition(this.cleanConditions[index].ValueCondition, this.value, this.index);
                    if (!found) index++;
                }
                // Get value if meet condition
                if (found) {
                    var expression = this.cleanConditions[index].Value.replace('{{value}}', this.formatValue);
                    return expression;
                }
            },
            customClass() {
                let cellClass = 'cellNumberType';
                if (this.classToApply)
                    cellClass += ' ' + this.classToApply;
                return cellClass;
            },
        },
        methods: {

        }
    }

</script>
<style scoped>
    .cellNumberType {
        text-align: right;
    }
</style>